<script setup lang="ts">
import BackstageButton from '@/components/common/BackstageButton.vue';
import BackstagePopoverPanel from '@/components/common/BackstagePopoverPanel.vue';
import { ButtonVariant } from '@/models/button-variant.enum';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import HeaderTriggerButton from './HeaderTriggerButton.vue';

const userStore = useUserStore();
const { logout } = userStore;
const { userProfile } = storeToRefs(userStore);

const userName = computed<string>(() => {
  return userProfile.value?.profile?.firstName || userProfile.value?.profile?.lastName
    ? `${userProfile.value?.profile?.firstName} ${userProfile.value?.profile?.lastName}`
    : 'User';
});

async function logoutButtonClick(event?: Event) {
  event?.preventDefault();
  logout();
}

const showAccountPanel = defineModel<boolean>({ required: true });
const onAccountTrigger = () => {
  showAccountPanel.value = true;
};
</script>

<template>
  <BackstagePopoverPanel v-model="showAccountPanel" @mouseleave="showAccountPanel = false">
    <template #trigger>
      <HeaderTriggerButton
        dataCy="account-icon"
        iconName="account"
        @click="onAccountTrigger"
        @mouseover="onAccountTrigger" />
    </template>
    <template #title> User </template>
    <template #body>
      <div class="account-container" data-cy="account-container">
        <div class="account-container-name" data-hj-suppress :title="userName">
          {{ userName }}
        </div>
        <!-- TODO: Need to update the data-cy values -->
        <div class="account-container-action" data-cy="user-name-menu">
          <BackstageButton
            :variant="ButtonVariant.SECONDARY"
            data-cy="logout-button-cnt"
            data-cy-button="logout-button"
            @click="logoutButtonClick">
            {{ $t('header.account.log_out') }}
          </BackstageButton>
        </div>
      </div>
    </template>
  </BackstagePopoverPanel>
</template>

<style scoped lang="scss">
.account-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &-name {
    padding: 1rem;
    font-size: 1rem;
    font-weight: 400;
    background-color: var(--field-bg-color);
  }
}
</style>
